/** @jsx jsx  */
import React, { memo } from "react";
import { SerializedStyles, jsx } from "@emotion/core";

export interface IWithStylesProps
    extends React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>,
        HTMLElement & HTMLAnchorElement
    > {
    as?: React.ElementType;
    elRef?: React.RefObject<any>;
    cssProps: SerializedStyles | (SerializedStyles | boolean)[];
    children?: React.ReactNode;
}

function WithStyles({ as = "div", cssProps, children, elRef, ...props }: IWithStylesProps) {
    const Component = as;

    return (
        <Component ref={elRef} css={cssProps} {...props}>
            {children !== undefined && children}
        </Component>
    );
}

export default memo(WithStyles);
